import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, Card, CardContent } from '@mui/material';
import { ROUTES } from '../../../config/routes';
import Info360Contenido from './Info360Contenido';
import Info360Header from './components/Info360Header';

function safeReturnTo(raw: string | null): string | null {
  if (!raw) return null;
  const value = raw.trim();
  if (!value.startsWith('/') || value.startsWith('//')) return null;
  return value;
}

const ClienteInfo360: React.FC = () => {
  const { nroCliente: nroClienteParam } = useParams<{ nroCliente: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const nroCliente = Number(nroClienteParam);
  const returnTo = safeReturnTo(searchParams.get('returnTo'));

  const handleVolver = () => {
    if (returnTo) {
      navigate(returnTo);
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(ROUTES.ventas.clientes.list);
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Card
        sx={{
          bgcolor: '#ffffff',
          borderRadius: 3,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          overflow: 'hidden',
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Info360Contenido
            nroCliente={nroCliente}
            accionSecundariaError={{ label: 'Volver', onClick: handleVolver }}
            renderHeader={(cliente) => (
              <Info360Header
                cliente={cliente}
                onVolver={handleVolver}
                onEditarMaestro={() => navigate(ROUTES.ventas.clientes.editar(cliente.nroCliente))}
              />
            )}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default ClienteInfo360;
